import {
  IPanelStyles,
  getTheme,
  mergeStyles,
  IDetailsListStyles,
  IDetailsRowStyles,
  getRTL,
  ILinkStyles,
  IButtonStyles,
  mergeStyleSets,
  IBreadcrumbStyles,
  IIconStyles
} from "@fluentui/react";

const theme = getTheme();
export const panelStyles: Partial<IPanelStyles> = {
  // headerText: {
  //   fontWeight: FontWeights.regular,
  //   color: theme.palette.themeDarkAlt
  // }
};

export const linkIconStyles: IIconStyles = {
  root: {
    display: "flex",
    marginLeft: 6,
    marginRight: 6,
    fontSize: 16,
    color: 'var(--db-accent-hover, #106ebe)'
  }
}

export const profilePanelStyles: Partial<IPanelStyles> = {
  // headerText: panelStyles.headerText,
  header: { paddingLeft: 15, paddingRight: 15 },
  content: { paddingLeft: 15, paddingRight: 15 }
}

export const uploadPanelStyles: Partial<IPanelStyles> = {
  // ...panelStyles,
  content: { paddingTop: 10 },
  footer: {
    backgroundColor: 'var(--db-bg, #fff)'
  },
};

export const settingsIconClass = mergeStyles({
  // color: theme.palette.themeDarkAlt,
  color: 'var(--db-fg, #201f1e)',
  cursor: "pointer",
  paddingRight: 5,
  fontSize: 16
});

export const detailListStyles: Partial<IDetailsListStyles> = {
  root: {
    margin: "0 0 0 0",
    padding: "0px",
    MsOverflowStyle: "scrollbar"
  },
  headerWrapper: {
    paddingTop: 0
  }
};

export const detailRowStyles: Partial<IDetailsRowStyles> = {
  root: {
    fontSize: "14px",
    selectors: {
      ":hover": { fontSize: "14px" }
    }
  }
};

export const detailRowLinkStyles: ILinkStyles = {
  root: {
    color: 'var(--db-fg, #323130)',
    ":hover": {
      color: 'var(--db-fg, #323130)',
      textDecoration: "underline"
    },
    maxWidth: "100%"
  }
};

export const detailRowPiiDetectedStyles: Partial<IDetailsRowStyles> = {
  root: {
    fontSize: "14px",
    backgroundColor: 'var(--db-pii-detected-bg, #ffebe5)',
    borderBottom: '1px solid var(--db-bg, rgb(255, 255, 255))',
    selectors: {
      ":hover": { backgroundColor: 'var(--db-pii-detected-hover-bg, #ffded4)' }
    }
  }
};

export const detailRowPiiNotDetectedStyles: Partial<IDetailsRowStyles> = {
  root: {
    fontSize: "14px",
    backgroundColor: 'var(--db-pii-ok-bg, #e7f9e6)',
    borderBottom: '1px solid var(--db-bg, rgb(255, 255, 255))',
    selectors: {
      ":hover": { backgroundColor: 'var(--db-pii-ok-hover-bg, #dff6dd)' }
    }
  }
};

export const detailRowPiiDetectedStylesCM: Partial<IDetailsRowStyles> = {
  root: {
    backgroundColor: 'var(--db-pii-detected-bg, #ffebe5)',
    borderBottom: '1px solid var(--db-bg, rgb(255, 255, 255))',
    selectors: {
      ":hover": { backgroundColor: 'var(--db-pii-detected-hover-bg, #ffded4)' }
    }
  }
};

export const detailRowPiiNotDetectedStylesCM: Partial<IDetailsRowStyles> = {
  root: {
    backgroundColor: 'var(--db-pii-ok-bg, #e7f9e6)',
    borderBottom: '1px solid var(--db-bg, rgb(255, 255, 255))',
    selectors: {
      ":hover": { backgroundColor: 'var(--db-pii-ok-hover-bg, #dff6dd)' }
    }
  }
};

export const clearButtonClass: string = mergeStyles({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  cursor: 'pointer',
  flexBasis: '32px',
  flexShrink: 0,
  padding: 0,
  margin: '-1px 0px',
  selectors: {
    '&:hover .ms-Button': {
      backgroundColor: 'var(--db-surface, #faf9f8)',
    },
    '&:hover .ms-Button-icon': {
      color: 'var(--db-fg, #323130)',
    },
    '.ms-Button': {
      borderRadius: getRTL(theme) ? '1px 0 0 1px' : '0 1px 1px 0',
    },
    '.ms-Button-icon': {
      color: 'var(--db-fg-muted, #605e5c)',
    },
  },
});

export const confirmDeleteButtonStyles: IButtonStyles = {
  root: {
    cursor: "unset",
  },
  rootHovered: {
    color: 'var(--db-fg, #323130)',
  }
};

export const editFilePropertiesButtonStyles: IButtonStyles = {
  root: {
    paddingTop: 5,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0
  }
};

export const dropZoneStyles: React.CSSProperties = {
  borderWidth: 2,
  borderStyle: "dashed",
  borderColor: 'var(--db-accent-hover, #106ebe)',
  boxSizing: "border-box"
}

export const dropZoneStyleSets = mergeStyleSets({
  dropzoneActive: {
    position: "relative",
    "*": {
      pointerEvents: "none"
    },
    ":after": {
      borderWidth: 2,
      borderStyle: "dashed",
      borderColor: 'var(--db-accent-hover, #106ebe)',
      boxSizing: "border-box",
      content: '" "',
      display: "block",
      pointerEvents: "none",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 999
    }
  }
});

export const dragZoneStyleSets = mergeStyleSets({
  dragzoneActive: {
    position: "relative",
    "*": {
      pointerEvents: "none"
    },
    ":after": {
      borderWidth: 2,
      borderStyle: "dashed",
      borderColor: 'var(--db-fg-muted, #605e5c)',
      boxSizing: "border-box",
      content: '" "',
      display: "block",
      pointerEvents: "none",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 999
    }
  }
});

export const fileIconHeaderIcon: string = mergeStyles({
  padding: 0,
  fontSize: '16px'
});

export const brandedActionButtonIconStyles: string = mergeStyles({
  marginLeft: 2,
  marginRight: 2,
  height: 16,
  width: 16
});

export const brandedCommandbarIconStyles: string = mergeStyles({
  marginLeft: 4,
  marginRight: 4,
  height: 16,
  width: 16
});

export const menuItemIconStyles: string = mergeStyles({
  marginLeft: 2,
  marginRight: 2
});

export const breadCrumbContainerStyles: React.CSSProperties = {
  height: 25
}

export const breadCrumbStyles: Partial<IBreadcrumbStyles> = {
  root: {
    marginTop: 0,
    marginBottom: 0
  },
  chevron: {
    fontSize: 10,
  },
  item: {
    fontSize: 12,
    lineHeight: 20,
    paddingLeft: 2,
    paddingRight: 2
  },
  overflowButton: {
    selectors: {
      "@media only screen and (max-width: 479px) and (min-width: 0px)": { paddingLeft: 0, paddingRight: 0 },
      ":hover": { color: 'var(--db-accent-hover, #106ebe)' }
    },
    paddingLeft: 0,
    paddingRight: 0
  }
};

export const previewWebPanelStyles: Partial<IPanelStyles> = {
  main: {
    overflow: "unset"
  },
  commands: {
    "@media all": {
      position: "relative",
      zIndex: 10
    }
  }
}

// A `previewWithFooterWebPanelStyles` / `previewFullHeightWebPanelStyles` variant used to live
// here, making `.ms-Panel-content` a flex column so a panel body could grow inside it instead of
// guessing `calc(100vh - …)`. It was removed: in practice the row it fed was not capped by it,
// so the body grew to its own content height, the panel itself gained a scrollbar, and anything
// pinned to the bottom of a column ended up below the fold. The panels here size their body off
// the viewport instead — see CMPlaceholderSuggestPanel. Do not reintroduce it without being able
// to watch the result render.